import { createApi } from '@reduxjs/toolkit/query/react';

import type { GetAuthenticatedTilesResponse } from '@helsenorge/core-cms/types/entities/helsenorge.corefrontend.internalapi.entities.entities';
import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { createFetchBaseQuery } from '@helsenorge/framework-utils/hn-proxy-service-redux';

const tilesApi = createApi({
  reducerPath: 'tilesApi',
  baseQuery: createFetchBaseQuery('corefrontendinternal'),
  endpoints: builder => ({
    getTiles: builder.query<GetAuthenticatedTilesResponse, LanguageLocales>({
      query: language => ({
        url: 'AuthenticatedTiles/v1',
        params: { culture: language.toLowerCase() },
      }),
    }),
  }),
});

export const { useGetTilesQuery } = tilesApi;

export default tilesApi;
